module.exports = __webpack_public_path__ + "media/images/phone/app-download-banner-bg-83f33510c254c224ead76468b3658abc.png";